import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import { NgDialogModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-copy-client-secret-dialog',
  templateUrl: './copy-client-secret-dialog.component.html',
  styleUrls: ['./copy-client-secret-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, InformationBoxComponent, MatTooltip],
})
export class CopyClientSecretDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public clientSecret: string,
    private _clipboard: Clipboard,
    private _snackBar: MatSnackBar
  ) {}

  copy(): void {
    this._snackBar.open('Copied to clipboard');
    this._clipboard.copy(this.clientSecret);
  }
}
